module.exports = __webpack_public_path__ + "img/image-regular.776de9d0.svg";